"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A provider is a way of achieving dependency injection. Typically dependency injection is
 * used for injecting parameters into a class (see Java Spring or .NET), but this is mostly
 * about injecting configuration (urls, error handlers, etc)
 *
 * The return value of this function
 * is a function to register a dependency (registerProvider) and an asynchronous function to
 * retrieve the dependency.
 *
 *
 * Note that the signature of the parameter of registerProvider matches the signature of the
 * provideValue function: () => Promise<T>
 *
 * It returns a promise because it is more flexible to where the dependencies are coming from.
 *
 * Usage:
 *
 * import createProvider from "@fuze/apis-core/dist/provider"
 *
 * const { registerProvider as registerUrlProvider, provideValue as getUrl } = createProvider<string>()
 *
 * async function getEntities() {
 *   const url = await provideValue()
 *   return makeApiCall(url)
 * }
 *
 * export { registerUrlProvider, getEntities }
 */
function createProvider() {
    var storedProvider = null;
    function registerProvider(provider) {
        storedProvider = provider;
    }
    function provideValue() {
        return storedProvider();
    }
    return { registerProvider: registerProvider, provideValue: provideValue };
}
exports.default = createProvider;
